import { LSystemInstructions } from 'entities/instruction/LSystemInstructions';
import Instruction from 'entities/instruction/Instruction';

export type DrawingCallbacks = {
    forward: () => void;
    turnLeft: () => void;
    turnRight: () => void;
    pitchUp: () => void;
    pitchDown: () => void;
    tiltLeft: () => void;
    tiltRight: () => void;
    setColor: (instruction: Instruction) => void;
    clear: () => void;
    push: () => void;
    pop: () => void;
};

class DrawingController {
    drawingCallbacks: DrawingCallbacks;
    constructor(drawingCallbacks: DrawingCallbacks) {
        this.drawingCallbacks = drawingCallbacks;
    }

    //TODO - add a 'limit' so we can process this in batches
    //instead of all at once.
    draw(instructions: LSystemInstructions): void {
        this.drawingCallbacks.clear();
        let instruction: Instruction | null = null;
        do {
            instruction = instructions.next();
            this.dispatch(instruction);
        } while (instruction !== null);
    }

    private dispatch(instruction: Instruction | null): void {
        switch (instruction) {
            case Instruction.FORWARD:
                this.drawingCallbacks.forward();
                return;
            case Instruction.LEFT:
                this.drawingCallbacks.turnLeft();
                return;
            case Instruction.RIGHT:
                this.drawingCallbacks.turnRight();
                return;
            case Instruction.COLOR_RED:
            case Instruction.COLOR_ORANGE:
            case Instruction.COLOR_YELLOW:
            case Instruction.COLOR_GREEN:
            case Instruction.COLOR_BLUE:
            case Instruction.COLOR_PURPLE:
            case Instruction.COLOR_BLACK:
                this.drawingCallbacks.setColor(instruction);
                return;
            case Instruction.PUSH:
                this.drawingCallbacks.push();
                return;
            case Instruction.POP:
                this.drawingCallbacks.pop();
                return;
            case Instruction.UP:
                this.drawingCallbacks.pitchUp();
                return;
            case Instruction.DOWN:
                this.drawingCallbacks.pitchDown();
                return;
            case Instruction.TILT_LEFT:
                this.drawingCallbacks.tiltLeft();
                return;
            case Instruction.TILT_RIGHT:
                this.drawingCallbacks.tiltRight();
                return;
        }
    }
}

export default DrawingController;
